<template>
	<div class="study">
		<publicHeader @child-event="parentEvent"></publicHeader>
		<personalHeader :myInfo="myInfo"></personalHeader>
		
		<div class="personal bg_gray">
			<div class="w1200 flex">
				<personalNav :current="current"></personalNav>
				<div class="personal_r bg_white radius8">
					<div class="personal_title mab20">
						<i class="f20px cl_dark mar10">我的订单</i>
						<span class="cl_gray mal10"></span>
					</div>
					<div class="payment">
						<table class="payment_order mab20" v-for="(item,index) in list" :key="index">
							<thead class="f16px cl_dark">
								<tr>
									<td>{{item.add_time}}</td>
									<td colspan="3">订单号：{{item.order_no}}</td>
								</tr>
							</thead>
							<tbody>
								<tr class="bold">
									<td width="350px">名称</td>
									<td width="200px">有效期</td>
									<td width="150px">价格</td>
									<td></td>
								</tr>
								<tr class="cl_dark">
									<td>{{item.level_data.name}}</td>
									<td>{{item.level_data.period}}天</td>
									<td>{{item.pay_money}}</td>
									<td>{{item.status == "done" ? "已完成" : "" || item.status == "bef_pay" ? "已关闭" : "" || item.status == "close" ? "已关闭" : ""}}</td>
								</tr>
							</tbody>
						</table>
						<div class="famous_page flex" v-if="list.length > 0">
							<div class="famous_page_l f16px cl_gray"> </div>
							<div class="famous_page_r cl_dark">
								<el-pagination background layout="prev, pager, next"
								@current-change="handleCurrentChange" :page-size="pageSize" :current-page="currentPage" :total="total"></el-pagination>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<vfooter></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import vfooter from '../../components/footer.vue'
	import personalHeader from '../../components/personal_header.vue'
	import personalNav from '../../components/personal_nav.vue'
	export default {
	  name: 'order',
		components: {
			publicHeader,
			vfooter,
			personalHeader,
			personalNav,
		},
	  props: {
	    
	  },
		data () {
			return {
				myInfo: {},
				current: {
					navCur: 2,
					listCur: 3,
				},
				list: [],
				currentPage: 1, //当前页数
				pageSize: 10, //每页数量
				total: 0, //总页数
			}
		},
		mounted() {
			this.getOrder();
		},
		created() {
			
		},
		methods: {
			parentEvent (data) {
				this.myInfo = data;
			},
			getOrder () {
				this.$get("/api/levelorder/get_level_order_data",{
					token: localStorage.getItem("token"),
					page: this.currentPage,
					limit: this.pageSize,
				})
				.then(res => {
					this.list = res.data.data;
					this.total = res.data.total;
				});
			},
			handleCurrentChange: function(currentPage){
				this.currentPage = currentPage;
				this.getOrder();
			},
		},
	}
</script>

<style>
</style>
